import { render, staticRenderFns } from "./TracksSlider.vue?vue&type=template&id=2873a5cc&"
import script from "./TracksSlider.vue?vue&type=script&lang=ts&"
export * from "./TracksSlider.vue?vue&type=script&lang=ts&"
import style0 from "./TracksSlider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports